import { requestCreator } from "../../common/actions/VisitApi";
import { EntitiesMap, CompanyMembership, CompanyMembershipSection } from "../entities";

export interface UpdateMembershipSectionResponse {
  result: EntityId;
  entities: EntitiesMap;
}

export interface CreateMembershipSectionResponse {
  result: EntityId;
  entities: EntitiesMap;
}

export interface UpdateMembershipsInBatchResponse {
  result: EntityId[];
  entities: EntitiesMap;
}

/**
 * Create a request action to load memberships about a company
 */
export const requestToLoadMemberships = requestCreator<
  { companyId: string },
  { result: EntityId[]; entities: EntitiesMap },
  Error
>(params => ({
  path: "/api/v2/company_memberships",
  // TODO(KentoMoriwaki): Allow to override query params by arguments or extending
  query: {
    company_id: params.companyId,
    per_page: 1000,
    fields:
      // tslint:disable-next-line:max-line-length
      "id,display_order,user.id,user.name,user.avatar.id,user.avatar.url,user.profile.id,user.profile.position,section.id,section.name",
    include: "user,user.avatar,user.profile,section",
  },
  method: "GET",
}));

/**
 * Create a request action to load membership_sections about a company
 */
export const requestToLoadMembershipSections = requestCreator<
  { companyId: string },
  { result: EntityId[]; entities: EntitiesMap },
  Error
>(params => ({
  path: "/api/v2/company_membership_sections",
  // TODO(KentoMoriwaki): Allow to override query params by arguments or extending
  query: { company_id: params.companyId, per_page: 1000, fields: "id,display_order,name,description" },
  method: "GET",
}));

/**
 * Create a request action to update membership_section
 */
export const requestToUpdateMembershipSection = requestCreator<
  CompanyMembershipSection,
  UpdateMembershipSectionResponse,
  Error
>(section => ({
  path: `/api/v2/company_membership_sections/${section.id}`,
  query: {
    fields: ["id", "name", "description", "display_order"].join(","),
    include: [].join(","),
  },
  method: "PUT",
  body: section,
}));

/**
 * Create a request action to create new membership_section
 */
export const requestToCreateMembershipSection = requestCreator<
  CompanyMembershipSection,
  CreateMembershipSectionResponse,
  Error
>(section => ({
  path: "/api/v2/company_membership_sections",
  query: {
    fields: ["id", "name", "description", "display_order"].join(","),
    include: [].join(","),
  },
  method: "POST",
  body: {
    ...section,
    company_id: section.company,
  },
}));

/**
 * Create a request action to delete membership_section
 */
export const requestToDeleteMembershipSection = requestCreator<EntityId, undefined, Error>(id => ({
  path: `/api/v2/company_membership_sections/${id}`,
  method: "DELETE",
}));

/**
 * Create a request action to update memberships in batch
 */
export const requestToUpdateMembershipsInBatch = requestCreator<
  CompanyMembership[],
  UpdateMembershipsInBatchResponse,
  Error
>(memberships => {
  return {
    path: `/api/v2/company_memberships/batch_update`,
    method: "PATCH",
    // TODO(KentoMoriwaki): Allow to override query params by arguments or extending
    query: {
      fields: ["id", "display_order", "featured_display_order", "section.id"].join(","),
      include: ["section"].join(","),
    },
    body: {
      company_memberships: memberships.map(membership => {
        // Mapping associated entity to "_id" format
        return {
          ...membership,
          company_membership_section_id: membership.section,
        };
      }),
    },
  };
});



// WEBPACK FOOTER //
// ./frontend/src/company_memberships/api/index.ts